import { render, staticRenderFns } from "./PlanGroupForm.vue?vue&type=template&id=d963c6dc&"
import script from "./PlanGroupForm.vue?vue&type=script&lang=js&"
export * from "./PlanGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports